import { Book } from "@app/types";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.scss";
import { Images } from "@assets/images";
import { BookOption, BookOptionName, RoutePath } from "@app/constants";
import clsx from "clsx";
import { formatMoneyVN } from "@app/utils/util";
import { useNavigate } from "react-router-dom";

type TopGoodBooksProps = {
  books: Book[];
};

const settings: Settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: true,
  pauseOnFocus: true,
  pauseOnDotsHover: true,
  autoplay: true,
  autoplaySpeed: 5000,
  focusOnSelect: false,
  arrows: false,
};

const TopGoodBooks = ({ books }: TopGoodBooksProps) => {
  const bookChunks = [];

  for (let i = 0; i < books.length; i += 9) {
    bookChunks.push(books.slice(i, i + 9));
  }

  const navigate = useNavigate();

  const handleItemClick = (book: Book) => {
    navigate(`/${RoutePath.BOOK_DETAIL}/${book.id}`);
  };

  const renderBadge = (book: Book) => {
    if (book.bookOption === BookOption.PURCHASE && book.isAvailable) {
      return "Đã Mua";
    }

    return book.bookOption === BookOption.PURCHASE ? (
      <span>
        {formatMoneyVN(book.price)}
        <span className="underline">đ</span>
      </span>
    ) : (
      BookOptionName[book.bookOption]
    );
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {bookChunks.map((chunk, index) => (
          <div key={index} className="flex justify-center">
            <div className="grid-container">
              {chunk.map((book) => (
                <div key={book.id} className="flex gap-3 items-center">
                  <div className="relative">
                    <div
                      className={clsx(
                        "absolute z-50 top-0 right-0 px-3 py-[6px] rounded-tr-md rounded-bl-2xl text-sm font-medium font-[SVN-Gilroy] tracking-[0.028px]",
                        {
                          "bg-[#E6FFED] text-[#00A653]":
                            book.bookOption === BookOption.FREE,
                          "bg-[#FFFEE6] text-[#FFD500]":
                            book.bookOption === BookOption.VIP,
                          "bg-[#FFE4D6] text-[#FF7029]":
                            book.bookOption === BookOption.PURCHASE,
                        }
                      )}
                    >
                      {renderBadge(book)}
                    </div>
                    <img
                      className="max-w-[280px] max-h-[360px] min-w-[180px] min-h-[280px] rounded-lg cursor-pointer"
                      src={book.thumbnails[0]}
                      alt=""
                      onClick={() => handleItemClick(book)}
                    />
                  </div>
                  <div className="max-w-[175px]">
                    <div
                      className="text-[#333B47] font-[SVN-Gilroy] text-lg font-semibold tracking-[0.027px] cursor-pointer"
                      onClick={() => handleItemClick(book)}
                    >
                      {book.name}
                    </div>
                    <div className="text-[#657892] font-[SVN-Gilroy] text-sm font-medium tracking-[0.028px]">
                      {book.author}
                    </div>
                    <div className="mt-2 flex gap-3">
                      <div className="flex items-center gap-1">
                        <div>
                          <img src={Images.HeartGrayIcon.default} alt="" />
                        </div>
                        <div className="text-[#657892] font-[SVN-Gilroy] text-sm font-medium">
                          {book.insight.likeCount ?? 0}
                        </div>
                      </div>
                      <div className="flex items-center gap-1">
                        <div>
                          <img src={Images.Eye1GrayIcon.default} alt="" />
                        </div>
                        <div className="text-[#657892] font-[SVN-Gilroy] text-sm font-medium">
                          {book.insight.viewCount ?? 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TopGoodBooks;
